/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { cssMap, jsx } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { ChatPillIcon } from '@atlaskit/rovo-agent-components';
import { token } from '@atlaskit/tokens';
import { AgentDropdownMenu } from '@atlassian/conversation-assistant-agent';
import { type AssistanceServiceInputParam } from '@atlassian/conversation-assistant-service';

import { messages } from './messages';

const styles = cssMap({
	chatToAgentButtonContainer: {
		width: '100%',
	},
	chatToAgentButtonWrapper: {
		display: 'flex',
		justifyContent: 'center',
		fontWeight: token('font.weight.medium'),
	},
	chatPillText: {
		wordBreak: 'break-word',
		textAlign: 'left',
		whiteSpace: 'pre-wrap',
	},
	chatPillIconWrapper: {
		minWidth: '20px',
		height: '20px',
	},
});

type AgentActionsProps = {
	agentId: string;
	isAgentCreatedByUser: boolean;
	onEditAgent: () => void;
	onCopyAgent: () => void;
	onDuplicateAgent: () => void;
	onDeleteAgent: () => void;
	onChatClick: () => void;
	isForgeAgent: boolean;
} & AssistanceServiceInputParam;

export const AgentActions = ({
	onEditAgent,
	onDeleteAgent,
	onDuplicateAgent,
	onCopyAgent,
	onChatClick,
	isAgentCreatedByUser,
	agentId,
	isForgeAgent,
	assistanceServiceParams,
}: AgentActionsProps) => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.100">
			<Box xcss={styles.chatToAgentButtonContainer}>
				<Button shouldFitContainer onClick={onChatClick}>
					<div css={styles.chatToAgentButtonWrapper}>
						<Inline space="space.050">
							<Box xcss={styles.chatPillIconWrapper}>
								<ChatPillIcon />
							</Box>
							<Box xcss={styles.chatPillText}>{formatMessage(messages.actionChatToAgent)}</Box>
						</Inline>
					</div>
				</Button>
			</Box>

			<AgentDropdownMenu
				agentId={agentId}
				isAgentCreatedByUser={isAgentCreatedByUser}
				isForgeAgent={isForgeAgent}
				onCopyAgent={onCopyAgent}
				onDeleteAgent={onDeleteAgent}
				onDuplicateAgent={onDuplicateAgent}
				onEditAgent={onEditAgent}
				loadPermissionsOnMount
				assistanceServiceParams={assistanceServiceParams}
			/>
		</Inline>
	);
};
